var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enterprise-item",on:{"click":function($event){return _vm.toDetail(_vm.data)}}},[_c('img',{attrs:{"src":_vm.data.image,"alt":""}}),_c('el-tooltip',{attrs:{"effect":"light","content":_vm.data.title,"placement":"bottom"}},[_c('p',{staticClass:"line-one-ellipsis"},[_vm._v(_vm._s(_vm.data.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }